import { Injectable } from "@angular/core";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { filter } from "rxjs/operators";
import { FiltersAbstractService } from "src/app/common-page-components/classes/filters-abstract-service";
import { AthleteWCupPageStore } from "src/app/common-page-components/stores/entities-store/world-cup-athlete.store";
import { ComboStoreComponent, EventAthleteResultsCombo, YesNotCombo } from "src/app/common-page-components/stores/filters-store/filters-store";
import { FiltersAthleteGeneralService } from "../../services/filters-athlete-general.service";
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: "root",
})
export class AthleteWcupRankingFiltersFinalsService extends FiltersAbstractService {

  /**
   * Categories combo from general athlete to get the athlete categories.
   *
   * @memberof AthleteWcupRankingFiltersFinalsService
   */
  athleteCategoriesCombo = this.common_service.athleteCategoriesCombo;

  /**
   * Categories combo from general athlete to get the athlete categories.
   *
   * @memberof AthleteWcupRankingFiltersFinalsService
   */
  categoriesCombo = new ComboStoreComponent('Categories: ', 'CatName', 'wcrup-category-combo', undefined, undefined, undefined, undefined);

  /**
   * A lock to only dispatch the events on the method getDataStreamWithFilters when categories are ready and filtered.
   *
   * @memberof AthleteWcupRankingFiltersFinalsService
   */
  categoriesReady = new BehaviorSubject(false);


  /**
   * Event type combo.
   *
   * @memberof AthleteWcupRankingFiltersFinalsService
   */
  eventTypeCombo = new EventAthleteResultsCombo(
    "Event:",
    "event-results-combo"
  );

  /**
   * Podiums only filter.
   *
   * @memberof AthleteWcupRankingFiltersService
   */
  podiumsOnly = new YesNotCombo("Podiums", "wcup-podiums-only", { Name: "No", Value: false });

  /**
   * The filters of the BootstrapAthleteWcupRankingComponent page.
   *
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  filtersType = [
    this.categoriesCombo.filterInfo,
    this.eventTypeCombo.filterInfo,
    this.podiumsOnly.filterInfo
  ];
  constructor(public common_service: FiltersAthleteGeneralService) {
    super();
    this.eventTypeCombo.setData([].concat(...(this.eventTypeCombo['extraOptions']).map(value => value.item).filter(value => ['Individual', 'Mixed Team'].indexOf(value.Name) != -1)), { Name: "Individual", Value: 0 });
    const categoriesToSet = [].concat(...this.athleteCategoriesCombo.data.filter(value => ['RM', 'RW', 'CM', 'CW'].indexOf((value as any).Cat) != -1));
    this.categoriesCombo.setData(categoriesToSet, categoriesToSet[0])
  }

  /**
   * {@inheritdoc}
   *
   * @return {*}  {void}
   * @memberof AthleteWcupRankingFiltersService
   */
  generateDefaultValues(): void {
    return;
  }

  /**
   *
   * @inheritdoc
   * @returns {import("rxjs").Observable<any>}
   * @memberof AthleteWcupRankingFiltersService
   */
  getDataStreamWithFilters() {
    return combineLatest([this.categoriesReady.asObservable(), this.categoriesCombo.comboData, this.eventTypeCombo.comboData, this.podiumsOnly.comboData]).pipe(
      filter(a => a[0] === true),
      map(a => {
        return [a[1], a[2], a[3]]
      })
    );

  }
}
